import 'antd/lib/steps/style'
import { Steps } from './steps'
import './style/index.less'

export * from './steps'

export default Steps
